import { createReduxStore, register } from '@wordpress/data';
import reducer from './reducer';
import * as actions from './actions';
import * as resolvers from './resolvers';
import selectors from './selectors';

export const PAYONEER_STORE_KEY = 'payoneer-checkout';

export const payoneerStore = createReduxStore( PAYONEER_STORE_KEY, {
	reducer,
	actions,
	selectors,
	resolvers
} );

register( payoneerStore );

